export const isStateChanged = (currentState, defaultState) => {
  return JSON.stringify(currentState) !== JSON.stringify(defaultState);
};